// Utility functions for JWT token handling

export function getTokenExpiry(token: string): number | null {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    const payload = JSON.parse(jsonPayload);
    return typeof payload.exp === 'number' ? payload.exp : null;
  } catch {
    return null;
  }
}

export function isTokenExpiringSoon(token: string, thresholdSeconds = 600): boolean {
  const exp = getTokenExpiry(token);
  if (!exp) return false;
  const now = Math.floor(Date.now() / 1000);
  return exp - now < thresholdSeconds;
}

// Refresh the access token via /oauth/refresh if it's about to expire
export async function refreshTokenIfNeeded(token: string | null): Promise<string | null> {
  if (!token) return null;
  if (!isTokenExpiringSoon(token, 600)) return token;
  try {
    const res = await fetch('/api/oauth/refresh', {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    const data = await res.json();
    if (res.ok && data.access_token) {
      return data.access_token;
    }
  } catch {
    // refresh failed; fall through to return original token
  }
  return token;
}
